<template>
	<el-tabs v-model="activeTab" @tab-click="tabClicked" class="todo-block block el-table__first-el-indent">
		<el-tab-pane label="未读通告" name="public_notice">
			<el-table :show-header="false" :data="topUnreadPublicNotices" @row-click="onClickNotice" row-class-name="row">
				<el-table-column label="标题" prop="title" />
				<el-table-column label="日期" width="150">
					<template v-slot:default="slot">
						<p class="date">{{ slot.row.created_at | dateonly }}</p>
					</template>
				</el-table-column>
				<template v-slot:append v-if="topUnreadPublicNotices && topUnreadPublicNotices.length != 0"
					><router-link :to="{ name: 'publicNoticeList' }">
						<div class="todo-block-bottom">
							更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
								<use xlink:href="#icon-iconfillenter"></use>
							</svg></div
					></router-link>
				</template>
			</el-table>
		</el-tab-pane>
		<template
			v-if="
        $store.state.user.userInfo.type !=
          $api.account.types.SCHOOL_ADMIN.value &&
        ($store.state.user.userInfo.type ===
          $api.account.types.BUREAU_ADMIN.value &&
          $store.state.user.userInfo.bureau_admin.subject_id != 0)
      "
			><el-tab-pane label="待审核申报" name="declaration">
				<el-table
					:show-header="false"
					:data="topPendingApprovalDeclarations"
					@row-click="onClickDeclaration"
					row-class-name="row"
				>
					<el-table-column label="流程" prop="declaration_process.name" />
					<el-table-column prop="author.realname" align="left" label="发起人" :width="14 * 6 + 70" />

					<el-table-column label="创建日期" width="150">
						<template v-slot:default="slot">
							<p class="date">{{ slot.row.created_at | dateonly }}</p>
						</template>
					</el-table-column>
					<template v-slot:append v-if="topPendingApprovalDeclarations && topPendingApprovalDeclarations.length != 0"
						><router-link :to="{ name: 'declarationList' }">
							<div class="todo-block-bottom">
								更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
									<use xlink:href="#icon-iconfillenter"></use>
								</svg></div
						></router-link>
					</template>
				</el-table>
			</el-tab-pane>
			<el-tab-pane label="进行中测评" name="test">
				<el-table :show-header="false" :data="topWorkingTests" @row-click="onClickTest" row-class-name="row">
					<el-table-column label="名称" prop="name" />

					<el-table-column align="left" label="类型" :width="14 * 6 + 70">
						<template v-slot:default="slot">{{ test_type_str(slot.row.type) }}</template>
					</el-table-column>

					<el-table-column label="创建日期" width="150">
						<template v-slot:default="slot">
							<p class="date">{{ slot.row.created_at | dateonly }}</p>
						</template>
					</el-table-column>
					<template v-slot:append v-if="topWorkingTests && topWorkingTests.length != 0"
						><router-link :to="{ name: 'testManagement', params: { sbid: subject_id } }">
							<div class="todo-block-bottom">
								更多<svg class="icon" aria-hidden="true" style="margin-left: 4px;">
									<use xlink:href="#icon-iconfillenter"></use>
								</svg></div
						></router-link>
					</template>
				</el-table>
			</el-tab-pane>
		</template>
	</el-tabs>
</template>

<script>
export default {
	data() {
		return {
			subject_id: null,
			activeTab: 'public_notice',
			topUnreadPublicNotices: [],
			topPendingApprovalDeclarations: [],
			topWorkingTests: []
		}
	},
	created() {
		this.refreshUnreadPublicNotice()

		if (this.$store.state.user.userInfo.type == this.$api.account.types.BUREAU_ADMIN.value)
			this.subject_id = this.$store.state.user.userInfo.bureau_admin.subject_id ?? null
	},
	methods: {
		test_type_str(v) {
			return this.$api.test.types.toText(v)
		},
		async refreshUnreadPublicNotice() {
			// 请求个人未读公告
			let unreadNoticeRes = await this.$api.user.listInbox({
				filterBy: {
					state: 0
				},
				paginate: {
					size: 5
				}
			})

			this.topUnreadPublicNotices = unreadNoticeRes.data
		},
		async refreshTestsList() {
			let res = await this.$api.test_serial.list(true, true, true, {
				paginate: {
					size: 5
				}
			})

			this.topWorkingTests = res.data
		},
		async refreshDeclarationsList() {
			let res = await this.$api.user.listDeclaration(0, {
				pov: 1,
				filterBy: {
					state: this.$api.declaration.state.IN_PROGRESS.value
				},
				paginate: {
					size: 5
				}
			})

			this.topPendingApprovalDeclarations = res.data
		},
		tabClicked(tabPanel) {
			switch (tabPanel.name) {
				case 'public_notice':
					// 请求未读
					this.refreshUnreadPublicNotice()
					break
				case 'test':
					this.refreshTestsList()
					break
				case 'declaration':
					this.refreshDeclarationsList()
					break
			}
		},
		onClickNotice(row) {
			this.$router.push({
				name: 'publicNoticeView',
				params: { id: row.id }
			})
		},
		onClickTest(row) {
			this.$router.push({
				name: 'teacherTestSerialDetail',
				params: { seid: row.serial }
			})
		},
		onClickDeclaration(row) {
			this.$router.push({
				name: 'declarationView',
				params: { id: row.id }
			})
		}
	}
}
</script>

<style lang="scss">
.todo-block {
	overflow: hidden;
	.todo-block-bottom {
		text-align: center;
		height: 40px;
		line-height: 40px;
		background-color: #f9f9f9;
		color: #cccccc;
		margin: 20px 20px;
		border: 1px solid #ebeef5;
		box-sizing: border-box;
		border-radius: 3px;
	}
}
</style>
